<template>
  <div class="home-toast common-toast-wrapper" @click.self="hideHomeToast">
    <div class="img-wrap" v-if="currentImg">
        <div style="position: relative">
          <img
            :src="currentImg.qnUrl"
            @click="handleClick"
            v-log="{
              event_type: 'show',
              event_name: '开屏弹窗',
              event_data: {
                name: currentImg.name || '无名称',
              }
            }"
          />
        </div>
        <img
          v-if="currentImg.aniName"
          class="btn animated"
          :class="currentImg.aniName"
          :src="currentImg.btnUrl"
          :style="durationStyle"
          @click="handleClick"
          v-log="{
            event_type: 'show',
            event_name: '开屏弹窗按钮',
            event_data: {
              aniName: currentImg.aniName,
              aniDuration: currentImg.aniDuration,
              name: currentImg.type,
            }
          }"
        />
      <img src="../../../imgs/icon/toast-top-close.png" class="close" @click="hideHomeToast" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  utils, http, storekeys,
} from '@/libs/interfaces';
import get from 'lodash/get';
import { reportPay } from '@/libs/utils/log/log';
import mixinOldVip from '@/mixins/vip-toast-test';
import { raisePaymentWithAb } from '@/libs/utils/raisePaymentWithAb'
import {
  thirdSplashPopup, vipHotsongsOld, homeToastBy82, firstHomeToastOld, firstHomeToastOldHotsongs, vipExperienceToast,
  oldUserPop2,
  vipSecondHomeToast,
  newToastXN,
} from '@/libs/app/config/payment';
import { newRole4DayCardConfig, newRole4MonthSkuDiscount7, newRole4MonthSkuDiscount90 } from '@/libs/utils/consts';
import { kaiping3Role2 } from '../../../libs/app/config/home';

const EXPIRATION_HOURS = 0.25;
export default {
  mixins: [mixinOldVip],
  data() {
    return {
      imgWrap: [],
      homeToastShow: false,
      currentImg: null,
    };
  },
  computed: {
    ...mapState({
      unionid: (state) => state.unionid,
      ktv_id: (state) => state.ktvid,
      is_vip: (state) => state.is_vip,
      role: (state) => state.role,
      bless_path: (state) => state.bless_path,
      is_bind: (state) => state.bind_status,
      have_photo: (state) => state.have_photo,
      photo_path: (state) => state.photo_path,
      have_gift: (state) => state.have_gift,
      isGold: (state) => state.isGold,
      isGrayscale: (state) => state.isGrayscale, // 是否是灰度测试用户
      wxconfig: (state) => state.wxconfig,
      isolduser: (state) => state.is_old_user,
      goldPrice: (state) => state.goldPrice,
      is72hour: (state) => state.is_72hour,
      is_low_price: (state) => state.is_low_price,
      vip_endtime: (state) => state.vip_endtime,
      is_leike_device: (state) => state.is_leike_device,
      is_bar_device: (state) => state.is_bar_device,
      presentVipPackages: (state) => state.presentVipPackages,
      hasFreeVipM: (state) => state.hasFreeVipM,
      isFreeVipM: (state) => state.isFreeVipM,
      durationStyle() {
        return `animation-duration: ${this.currentImg.aniDuration}s;`;
      },
      isOldVip() {
        return this.role === 'role4'
      },
      showKtvInfo() {
        // 非雷客、酒吧和会所并且已绑定房台
        return !this.is_leike_device && !this.is_bar_device && !this.is_huisuo_device && this.ktv_id
      },
      homeToastTimesNum() {
         return ['role5'].includes(this.role) ? 1 : 2
       }
    }),
  },
  watch: {
    // getVipData不能保证isGold先返回后执行adToastVIP，会出现金主领取弹窗和homeToastBy82弹窗
    isGold() {
        this.$RaiseNewPayment({ action: 'close' });
    },
  },
  methods: {
    /**
     * 部分端/场景下 `role` 可能由接口异步回填，弹窗逻辑需要等待一小段时间再执行。
     */
    waitForRoleReady(timeoutMs = 2000, intervalMs = 50) {
      // role 可能为 ''/null/undefined 等 falsey
      if (this.role) return Promise.resolve(this.role);
      return new Promise((resolve) => {
        const start = Date.now();
        const timer = setInterval(() => {
          if (this.role) {
            clearInterval(timer);
            resolve(this.role);
            return;
          }
          if (Date.now() - start >= timeoutMs) {
            clearInterval(timer);
            resolve(null);
          }
        }, intervalMs);
      });
    },
    hideHomeToast() {
      if (get(this.currentImg, 'route', '') === 'experience') {
        // this.$store.commit('SET_FANS_MODAL_VIP', true)
        // _hmt.push(['_trackEvent', '首页-1.9体验会员弹窗', '引导关注弹窗'])
      }
      this.$store.commit('SAVE_HOME_TOAST', false);
      this.$store.commit('SET_ORDER_LIST', true);
    },
    getAction() {
      const fields = this.is_vip ? 'vip' : '非vip';
      if (this.currentImg.action == 2) {
        this.$sendLog({
          tp: `开屏弹窗${fields}开通月vip`, desc: `开屏弹窗${fields}开通月vip`, category: `开屏弹窗${fields}开通月vip`, optLabel: `开屏弹窗${fields}开通月vip`,
        });
        this.$store.dispatch('openVip', {
          memberId: 2,
          callback: () => {
            if (this.have_gift) {
              this.$store.dispatch('sendSpecialEffict');
            }
            this.$store.dispatch('getIsVip');
            this.$router.push('/thunder/vip_success');
          },
          pay_enter: 'homeBannerVip',
        });
      }
    },
    handleClick() {
      this.$sendLog({
        event_type: 'click',
        event_name: '开屏弹窗点击',
        event_data: {
          name: this.currentImg.name || '无名称',
        },
      });
    //   if (this.currentImg.weappId) return;
      if (this.currentImg.action) {
        this.getAction();
        return;
      }
      const name = get(this.currentImg, 'route', '');
      if (this.currentImg.linkType === '1') {
        if (name.includes('http')) {
          location.href = name;
        } else {
          location.href = process.env.BASE_URL + name;
        }
        return;
      }
      switch (name) {
        case 'vip':
          this.$router.push('/thunder/openvip?fromType=coopenAdvertising');
          this.hideHomeToast();
          break;
        case 'experience': {
          const price = this.isGrayscale ? '290' : '190';
          utils.util.buyVipPlus({
            memberId: 3,
            pay_fee: price,
            $this: this,
            pay_enter: 'guideVip',
            callback: () => {
              this.hideHomeToast();
            },
          });
          break;
        }
        case 'bless':
          if (!this.is_bind) {
            this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
          }
          this.$router.push(`${this.bless_path}?fromType=coopenAdvertising`);
          this.hideHomeToast();
          break;
        case 'pic':
          if (!this.is_bind) {
            this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
          }
          this.$router.push(`${this.photo_path}?fromType=coopenAdvertising`);
          this.hideHomeToast();
          break;
        case 'charge':
          this.$store.dispatch('charge', {
            callback: () => {
              this.$store.dispatch('getBalance');
              this.$router.push('/thunder/charge_success');
              this.hideHomeToast();
            },
            packageID: 0,
          });
          break;
        case 'gold_charter':
          if (!this.is_bind) {
            this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
          } if (!this.have_gift) {
            this.$messageBox.alert('暂不支持该功能', '');
          } else {
            if (this.isGold) {
              this.$router.push('/thunder/interact?fromType=coopenAdvertising');
            } else {
              this.$router.push('/thunder/gold_charter?fromType=coopenAdvertising');
            }
            this.$sendLog({
              event_type: 'click',
              event_name: '开屏弹窗',
              event_data: {
                action: '金主包场',
                is_vip: this.is_vip ? 'vip' : '非vip',
              },
            });
          }
          break;
        default:
          this.$router.push(`${name}?fromType=coopenAdvertising`);
          break;
      }
    },
    buy82Package() {
      const isRole3 = this.role === 'role3';
      const homeVipToast = {
        ...homeToastBy82,
        contentBg: 'https://qncweb.ktvsky.com/20251113/vadd/ecf1bf5d8534bab9281508524edad5e8.png',
        newCloseImg: 'https://qncweb.ktvsky.com/20250409/vadd/00434194d4988ce69f856d1aced62293.png',
        closeClassName: 'top-right-close-new',
        showAgreement: true,
        bottomAgreement: true,
        hideClose: false,
        limitClose: true,
        newCloseType: true,
        isShowGiveFriend: true,
        giveFriendConfig: {
          color: '#fc433f',
          bg: 'https://qncweb-back1.ktvsky.com/20211208/vadd/77090a60ffb6f3f79957f1d814867378.png',
          point: 'https://qncweb-back1.ktvsky.com/20211208/vadd/bf184008fa467c62c7e504f7f3349a58.png',
        },
        propStyleVar: {
          ...homeToastBy82.propStyleVar,
          buttonHeight: '22vw',
        },
        event: this,
      };

      if (isRole3) {
        homeVipToast.isSpecialPackages = true;
        homeVipToast.memberIdArr = [97, 121, 122];
        homeVipToast.price = [1490, 2190, 2990];
        homeVipToast.giveFriendPackages = [
          {
            pkg_id: 99, current_fee: 2980, desc: '1日体验+赠送好友', days: 1
          },
          {
            pkg_id: 118, current_fee: 4380, desc: '1个月+赠送好友', days: 30
          },
          {
            pkg_id: 119, current_fee: 5980, desc: '3个月+赠送好友', days: 365
          },
        ];
        homeVipToast.packagesContent = {
          month: ['24小时', '1个月', '3个月'],
          current: ['¥<span>0.62</span>/小时', '¥<span>0.03</span>/小时', '¥<span>0.01</span>/小时'],
          showFirstOrigin: true,
          countdownIndex: 1,
          origin: ['¥14.9', '¥21.9<i>¥29.9</i>', '¥29.9'],
          showTag: true,
          tagContent: ['', '续费减8元', ''],
        };
      }

      this.$RaiseNewPayment({
        ...homeVipToast,
        event: this,
      });
    },
    async getOldPopUps() {
      const params = { unionid: this.unionid };
      const { data = [] } = await http.get('https://m.ktvsky.com/vodc/song/myoffen', { params });
      // 开屏弹窗：减5元红包
      let config = {};
      const showFirstToast = utils.cookie.getCookie('showFirstToast');
      if (!showFirstToast) {
        config.isMonthDiscount = true;
        utils.cookie.setCookie(1, 6 / 24, 'showFirstToast');
      }
      const configRole4 = this.role === 'role4' && showFirstToast ? {
        isMonthDiscount: true,
        tagContentNew: ['', '70%的人选它', ''],
        propStyleVar: {
          ...firstHomeToastOld.propStyleVar,
          tagTop: '-0.6vw',
          tagPadding: '0 2.6vw',
          tagRadius: '1.33vw 1.33vw 1.33vw 0',
        },
      } : {};
      // 过期用户0-7天，月卡16.9
      const isRole4VipDay = this.role === 'role4' && utils.util.checkVipExpiredWithinDays({ $this: this, days: -7 })
      // 过期用户90天以上，月卡13.9
      const isRole4VipDay90 = this.role === 'role4' && !utils.util.checkVipExpiredWithinDays({ $this: this, days: -90 })
      let discountConfig = newRole4DayCardConfig;
      if (isRole4VipDay) {
        discountConfig = newRole4MonthSkuDiscount7;
      } else if (isRole4VipDay90) {
        discountConfig = newRole4MonthSkuDiscount90;
      }

      const configRole4New = this.role === 'role4' && !showFirstToast ? {
        discountIndex: 1,
        discountDayFee: '0.02',
        isDiscount: true,
        isMonthDiscount: true,
        ...discountConfig,
      } : {};
      const logEvent = (eventName) => {
        this.$sendLog({ event_type: 'show', event_name: eventName, event_data: { page_name: '开屏弹窗' } });
      };
      if (data.length) {
        logEvent('特权召回弹窗-有常唱');
        // 与 configRole4New 一致：首次有月卡优惠（showFirstToast 未写入前），cookie 有效期内再出则无优惠
        const kaipingCcFirstMonthDiscount = this.role === 'role4' ? !showFirstToast : undefined;
        this.$RaiseNewPayment({
          ...firstHomeToastOldHotsongs,
          ...config,
          event: this,
          hotsongSwiperData: data,
          mikeurl: 'https://qncweb-back1.ktvsky.com/20220726/vadd/e7e18917b0bf3cc6c691d8a825afcb24.png',
          className: data.length && 'hotsongs first-oldvip',
          bottomAgreement: true,
          ...configRole4New,
          kaipingCcFirstMonthDiscount,
        });
      } else {
        logEvent('特权召回弹窗');
        const basePageTp = 'new_oldvip_kaiping'
        const raisePayload = {
          ...firstHomeToastOld,
          ...config,
          ...configRole4,
          showTopUserCount: true,
          isShowTextCountDown: true,
          bottomAgreement: true,
          isShowGiveFriend: false, // B 方案默认：去掉赠好友
          contentBg: 'https://qncweb.ktvsky.com/20260408/vadd/f0af877fcc51770bd8e832ea7f6f8014.png',
          event: this,
        }
        // 开屏弹窗1：接入 AB（公共封装），接口返回配置合入弹窗；page_tp 前加 A/B
        await raisePaymentWithAb(this.$RaiseNewPayment, {
          experimentId: `${basePageTp}_${this.role}`,
          uid: this.unionid,
          pageTp: basePageTp,
          ...raisePayload,
        })
      }
    },
    // 免费体验VIP弹窗逻辑处理
    fetchVIPExperience() {
      const vipExperienceTime = parseInt(utils.cookie.getCookie(storekeys.vip_experience_60s) || -1, 10)
      if (vipExperienceTime > 0) {
        // 如果时差大于60s立即执行弹窗
        // 如果时差小于60s，则弹窗在60s-已经走过的时间后弹出
        const sub = Date.now() - vipExperienceTime
        const timeout = (sub >= 60 * 1000) ? 100 : (60 * 1000 - sub)
        setTimeout(() => {
          // 明早凌晨时间戳
          const tomorrowTimeStamp = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
          // 当前剩余秒数
          const duration = parseInt((tomorrowTimeStamp - Date.now()) / 1000, 10)
          utils.cookie.setCookie2(-1, duration - 60, storekeys.vip_experience_60s)
          this.$RaiseNewPayment({
            ...vipExperienceToast,
            event: this,
          })
        }, timeout)
        return true
      }
      return false
    },
    async getNotVipData() {
      let homeToastTimes = utils.cookie.getCookie('homeToastTimes') || 0;
      // 等待 role 异步回填，避免 role2 分流逻辑不执行
      await this.waitForRoleReady();
      this.hideHomeToast();
      this.$store.commit('SET_ORDER_LIST', false)
      switch (Number(homeToastTimes)) {
        case 0:
          if (this.isOldVip) {
            this.getOldPopUps();
          } else {
            this.oldVipToast('homeToast');
          }
          break;
        case 1:
          if (this.isOldVip) {
            this.openRedPacket2();
          } else if (['role2', 'role5'].includes(this.role)) {
            const basePageTp = 'kaiping_sdcs'
            await raisePaymentWithAb(this.$RaiseNewPayment, {
              experimentId: `${basePageTp}_${this.role}`,
              uid: this.unionid || this.openid,
              pageTp: basePageTp,
              ...newToastXN,
              event: this,
            })
          }
          break;
        default:
          this.showHotSong()
          break;
      }
      const isRole4 = this.role === 'role4';
      const hasReachedToastLimit = homeToastTimes >= this.homeToastTimesNum;
      const shouldResetToastTimes = (isRole4 && homeToastTimes == 1) || hasReachedToastLimit;
      homeToastTimes = shouldResetToastTimes ? 0 : homeToastTimes + 1;
      utils.cookie.setCookie(homeToastTimes, EXPIRATION_HOURS, 'homeToastTimes');
    },
    async getVipData() {
      await this.waitForRoleReady();
      let homeToastVipTimes = utils.cookie.getCookie('homeToastVipTimes') || 0;
      if (this.fetchVIPExperience()) {
        return
      }
      switch (Number(homeToastVipTimes)) {
        case 0:
          this.hideHomeToast();
          this.$store.commit('SET_ORDER_LIST', false);
          // this.is72hour 含义后端已经调整为 12小时
          if (this.is_vip && this.is72hour && !this.is_low_price) {
            if (this.role === 'role1') {
              this.checkPhotoPrivilegeForRole1();
            } else {
              this.buy82Package();
            }
          }
          break;
        case 1:
          if (this.role === 'role1') {
            const page_tp = vipSecondHomeToast.page_tp || 'kaiping_vip_two'
            this.$RaiseNewPayment({
              ...vipSecondHomeToast,
              page_tp,
              showAgreementText: true,
              propStyleVar: {
                ...vipSecondHomeToast.propStyleVar,
                buttonHeight: '20vw',
              },
              event: this,
            })
          } else if (this.role === 'role3') {
            const basePageTp = 'kaiping_vip_two_zs'
            await raisePaymentWithAb(this.$RaiseNewPayment, {
              experimentId: `${basePageTp}_${this.role}`,
              uid: this.unionid || this.openid,
              pageTp: basePageTp,
              ...vipSecondHomeToast,
              className: 'kaiping_vip_two new_oldvip_kaiping',
              event: this,
            })
          }
          break;
        default:
          break;
      }
      homeToastVipTimes = homeToastVipTimes >= 1 ? 0 : ++homeToastVipTimes;
      utils.cookie.setCookie(homeToastVipTimes, EXPIRATION_HOURS, 'homeToastVipTimes');
    },
    async showHotSong() {
      let currentHours = utils.cookie.getCookie('currentHours') || -1
      if (currentHours == -1) {
        currentHours = new Date().getHours()
      }
      let selectIndex = 0
      if (currentHours >= 2 && currentHours <= 20) {
        selectIndex = 0
      } else {
        selectIndex = 1
      }
      this.$sendLog({
        event_type: 'show',
        event_name: `开屏弹窗${this.isOldVip ? '老用户' : '新用户'}第三个弹窗`,
        event_data: {
          action: '展示',
        },
      });
      if (this.isOldVip) {
        this.$RaiseNewPayment({
          ...thirdSplashPopup,
          event: this,
        })
      } else if (this.role === 'role2') {
        const basePageTp = kaiping3Role2.page_tp || 'kaiping3_yzs'
        return raisePaymentWithAb(this.$RaiseNewPayment, {
          experimentId: `${basePageTp}_${this.role}`,
          uid: this.unionid,
          pageTp: basePageTp,
          ...kaiping3Role2,
          selectIndex,
          event: this,
        })
      } else if (this.role !== 'role1') {
        this.$RaiseNewPayment({
          ...vipHotsongsOld,
          selectIndex,
          event: this,
        });
      }
    },
  },
  mounted() {
    // 首页弹窗区分普通用户和VIP用户
    const photoPath = ['/thunder/photov2', '/thunder/photo_pag1']
    if (this.is_vip) {
      this.getVipData()
      this.$store.commit('SAVE_HOME_TOAST', false);
    } else if (photoPath.includes(this.photo_path) || this.bless_path === '/thunder/blessv1') {
      if (this.fetchVIPExperience()) {
        return
      }
      this.getNotVipData();
    } else {
      let homeToastTimes = utils.cookie.getCookie('homeToastTimes') || 0;
      this.homeToastShow = homeToastTimes < 5;
      this.currentImg = this.imgWrap[homeToastTimes];
      if (homeToastTimes * 1 === 3 && !this.have_photo) {
        homeToastTimes = 0;
      }
      this.currentImg = this.imgWrap[homeToastTimes];
      if (this.fetchVIPExperience()) {
        return
      }
      // 老用户复购测试
       if (homeToastTimes == 0) {
        if (this.isOldVip) {
          this.hideHomeToast();
          this.getOldPopUps();
        } else {
          this.oldVipToast('homeToast');
        }
        this.$store.commit('SET_ORDER_LIST', false)
      } else if (homeToastTimes == 1) {
        this.hideHomeToast();
        this.$store.commit('SET_ORDER_LIST', false)
        if (this.isOldVip) {
          this.openRedPacket2();
        } else {
          this.$RaiseNewPayment({
            ...oldUserPop2,
            page_tp: 'kaiping_sdcs',
            event: this,
          })
        }
      } else if (homeToastTimes == 2) {
        if (this.role === 'role2') {
          this.showHotSong()
        }
        this.hideHomeToast();
        this.$store.commit('SET_ORDER_LIST', false)
      }
      // 老用户复购测试-结束
      homeToastTimes = ++homeToastTimes > this.imgWrap.length - 1 ? 0 : homeToastTimes;
      utils.cookie.setCookie(homeToastTimes, EXPIRATION_HOURS, 'homeToastTimes');
    }
    if (this.currentImg) {
      if (this.currentImg.route === 'vip') {
        reportPay({
          page_tp: 'coopenAdvertising', // 详见文档
          active_tp: 3, // 弹窗展示
        });
      }
      if (this.currentImg.route === 'experience') {
        reportPay({
          page_tp: 'guideVip', // 详见文档
          active_tp: 3, // 弹窗展示
        });
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.home-toast {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: $z_index_important;
}
.btn {
  margin-top: 40px;
}
.img-wrap {
  width: 75vw;
  top: -10vw;
  img {
    width: 100%;
    height: auto;
  }
}
#launch-btn {
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: transparent;
  overflow: hidden;
}
</style>
